import Dialog from 'components/Dialog';
import React from 'react';
import Cardbox from '../Cardbox';
import PizzaPopup from './PizzaPopup';

const PizzaInstance = ({ data, isCombo, onChange, checked, disableIncrement, disabled }) => {
    const { name, description, defaultPrice } = data;
    const [showDialog, setShowDialog] = React.useState(false);
    React.useEffect(() => {
        if (disabled) setShowDialog(false);
    }, [disabled]);
    return (
        <>
            <Cardbox
                name={name}
                price={defaultPrice}
                img="pizza"
                imgUrl={data.imageUrl}
                onClick={() => {
                    if (disabled) return;
                    setShowDialog(true);
                }}
                isCombo={isCombo}
                checked={checked}
                desc={description}
                data={data}
                disabled={disabled}
            />
            {showDialog && !disabled && (
                <Dialog
                    title={name}
                    hideFooter
                    onClose={() => setShowDialog(false)}
                >
                    <PizzaPopup
                        disableIncrement={disableIncrement}
                        name={name}
                        data={data}
                        isCombo={isCombo}
                        onChange={(v) => {
                            onChange(v);
                            setShowDialog(false);
                        }}
                    />
                </Dialog>
            )}
        </>
    );
};

export default PizzaInstance;
